export const WUNDAAPI = 'https://wunda-geoportal-api.cismet.de';
//export const WUNDAAPI = "http://localhost:8890";
export const DRPROCESSOR = 'https://doc-processor.cismet.de';
//export const DRPROCESSOR = "http://localhost:8081";
